var gMap = {
	map 	: "",
	center 	: "",
	mk 		: "",
	bounds 	: "",
	spotPos : [],
	markers : [],
	infoWindow: "",
	canUseMap: false,
	init 	: function(lat, lng, mapBlock){
		let zoom 	= 15;
		gMap.spotPos = [];
		gMap.markers = [];
		let options = {
			center: new google.maps.LatLng(lat, lng),
			zoom: zoom,
			mapTypeId 		: google.maps.MapTypeId.ROADMAP,
			scrollwheel 	: false,
			disableDefaultUI: false,
			streetViewControl: false,
			scaleControl 	: false,
			panControl 		: true,
			zoomControl 	: false,
			overviewMapControl: true,
			mapTypeControl 	: false,
			mapTypeControlOptions: {
				position: google.maps.ControlPosition.TOP_CENTER
			},
			styles: ""
		};
		gMap.map = new google.maps.Map( $(mapBlock).get(0), options );
		gMap.infoWindow = new google.maps.InfoWindow({
			content: '<div class="bubble_content"><h5>スポット名</h5><a class="map_to_spot" href="" title="">詳しく見る</a></div>'
		});
		gMap.bounds = new google.maps.LatLngBounds();
		
		let marker 	= new google.maps.Marker({
			map 	: gMap.map,
			icon 	: {
				url : "/tokyo/wp-content/themes/stayplus/assets/images/icon/icon_spot_default.svg",
				scaledSize : new google.maps.Size(30, 42)
			},
			position: new google.maps.LatLng(lat,lng)
		});
		gMap.infoWindow.open(gMap.map, marker);
		gMap.bounds.extend(marker.position);

		google.maps.event.addDomListener(window, "resize", function() {
			let center = gMap.map.getCenter();
			google.maps.event.trigger(gMap.map, "resize");
			gMap.map.panTo(center);
		});
		if(page.param === "map"){
			common.sendPageView("deck_map", location.pathname);
		}
	},
	addSpot: function(lat, lng, mapBlock, i){
		let latlng = [lat, lng];
		let count = i;
		
		gMap.spotPos.push(latlng);
		gMap.markers[i] = new google.maps.Marker({
			map: gMap.map,
			icon: {
				url : "/tokyo/wp-content/themes/stayplus/assets/images/icon/icon_spot_default.svg",
				scaledSize : new google.maps.Size(30, 42)
			},
			position: new google.maps.LatLng(lat,lng)
		});
		google.maps.event.addListener(gMap.markers[count], 'click', (function(marker, i) {
			return function() {
				//alert(spots[i].name)
			}
		})(gMap.markers[count], i));
		
		
		
	},
	addCurrentLocation: function(lat, lng, accuracy){
		let marker = new google.maps.Marker({
			position: new google.maps.LatLng(lat,lng),
			map : gMap.map,
			icon: new google.maps.MarkerImage(
				"/tokyo/wp-content/themes/stayplus/assets/images/icon/icon_me.png",
				new google.maps.Size( 48, 49) , // 画像のオリジナルサイズ
				new google.maps.Point(0,0), // 基点となる位置 ここは変えません
				new google.maps.Point(12,12), // ここの値で位置を調整
				new google.maps.Size( 24, 24.5 ) , // 変更したい画像のサイズ
			)
		});
		new google.maps.Circle({
			map 		: gMap.map,
			center 		: new google.maps.LatLng(lat,lng),
			radius 		: accuracy,
			strokeColor	: '#0088ff',
			strokeOpacity: 0.8,
			strokeWeight: 1,
			fillColor	: '#0088ff',
			fillOpacity	: 0.2
		});
		gMap.bounds.extend(marker.position);
		gMap.map.fitBounds(gMap.bounds);
		gMap.map.panToBounds(gMap.bounds);
	},
	nav: function(){
		$(".list_spot_map li a").off().on("click", function(){
			let idx = parseInt( $(this).attr("data-num") );
			cardview.current = idx;
			gMap.activeSpot(true);
		});
	},
	selectedSpot: function(idx){
		gMap.map.panTo( new google.maps.LatLng( gMap.spotPos[idx][0], gMap.spotPos[idx][1] ));
		let title 	= $(".nav_map ul li").eq(cardview.current).find("a").attr("data-title");
		let link 	= $(".nav_map ul li").eq(cardview.current).find("a").attr("data-url");
		gMap.infoWindow.close();
		let txt = $("#deckslideshow a.deck_to_spot").attr("title");
		var clickEvent = 'common.sendMapEvent("' + link + '")';
		gMap.infoWindow = new google.maps.InfoWindow({
			content: "<div class='bubble_content'><h5><a class='map_to_spot' href='javascript:void(0);' title='" + txt + "' onClick='" + clickEvent + "'>" + title + "</a></h5></div>"
		});
		for(var i = 0; i  < gMap.markers.length; i++){
			if(i === idx){
				gMap.markers[i].setOptions({
					icon: {
						url: "/tokyo/wp-content/themes/stayplus/assets/images/icon/icon_spot_active.svg",// マーカーの画像を変更
						scaledSize : new google.maps.Size(30, 42)
					},
					zIndex: 200
				});
				gMap.infoWindow.open(gMap.map, gMap.markers[i]);
			}else{
				gMap.markers[i].setOptions({
					icon: {
						url: "/tokyo/wp-content/themes/stayplus/assets/images/icon/icon_spot_default.svg",// マーカーの画像を変更
						scaledSize : new google.maps.Size(30, 42)
					},
					zIndex: 100
				});
			}
		}
		common.nav();
		cardview.change();
	},
	activeSpot: function(needMove){
		$(".list_spot_map li a").removeClass("active");
		$(".list_spot_map li").eq(cardview.current).find("a").addClass("active");

		if(needMove){
			if(gMap.spotPos.length > 0){
				gMap.selectedSpot(cardview.current);
			}
		}
	}
}